Object.defineProperty(exports,"__esModule",{value:true});exports.











mapPositionRuleChange=mapPositionRuleChange;exports.





















mapFixtureRuleChange=mapFixtureRuleChange;var _MQTTActions=require('../actions/MQTTActions');var _dateUtil=require('../dateUtil');function mapPositionRuleChange(ruleProto){var ruleState=ruleProto.toObject();var positionRule=ruleState.positionRule;if(positionRule&&positionRule.positionRuleId>0){var positionRuleId=positionRule.positionRuleId;var updatedAt=ruleProto.getStatusUpdatedAt().toDate();return(0,_MQTTActions.updatePositionRuleState)({ruleId:positionRuleId,updatedAt:updatedAt});}return null;}function mapFixtureRuleChange(ruleProto){var _ruleProto$toObject=
ruleProto.toObject(),fixtureRule=_ruleProto$toObject.fixtureRule;


if(fixtureRule&&fixtureRule.fixtureRuleId>0){var
fixtureRuleId=fixtureRule.fixtureRuleId;
var updatedAt=ruleProto.getStatusUpdatedAt().toDate();

return(0,_MQTTActions.updateFixtureRuleState)({
ruleId:fixtureRuleId,
updatedAt:updatedAt});

}

return null;
}